import { FOUR_SET_LOADING, GET_FOUR, PUT_FOUR, GET_GROUP_CODE_4, FOUR_ERROR} from '../actions/types'
import {POST_FOUR, POST_OPK} from "../actions/actions";

const initialState = {
  four_list: {},
  group_code_4: [],
  loading: false,
  error: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_FOUR:
      return {
        ...state,
        four_list: {},
        four_list: action.payload,
        loading: false
      };
    case GET_GROUP_CODE_4:
      return {
        ...state,
        group_code_4: action.payload,
        loading: false
      };
    case PUT_FOUR:
      return {
        ...state,
        loading: false,
        four_list: {
          ...state.four_list,
          results: state.four_list.results.map(item => {
              if (item.id == action.payload.id) {
                  return action.payload
              } else
                  return item
          })
      }
      };
    case FOUR_SET_LOADING:
      return {
        ...state,
        loading: true,
        error: false
      };
    case FOUR_ERROR:
      return {
        ...state,
        loading: false,
        error: true
      }
    case POST_FOUR:
      return {
          ...state,
          loading: false,
            four_list: {
              ...state.four_list,
              results: [action.payload,...state.four_list.results]
            }
      };
    default:
      return state
  }
}
